import React from "react";
import { Row, Col } from "react-bootstrap";
import myImg from "../../Assets/syep14.png";
import Tilt from "react-parallax-tilt";
import Button from "react-bootstrap/Button";
import { useTranslation } from "react-i18next";

function Impact2({ onApply }) {
  const { t } = useTranslation();
  const videoId = "5mPU-mIQgoQ";

  const experienceItemsRaw = t("programs.internship.experience.items", { returnObjects: true });
  const beyondItemsRaw = t("programs.internship.beyond.items", { returnObjects: true });

  const experienceItems = Array.isArray(experienceItemsRaw) ? experienceItemsRaw : [];
  const beyondItems = Array.isArray(beyondItemsRaw) ? beyondItemsRaw : [];

  return (
    <>
      <section className="impact-section" id="internships">
        <Row className="impact-internship-row" style={{ justifyContent: "center" }}>
          <Col md={7} className="impact-internship-left">
            <div className="policy-card impact-copy-card impact-copy-card--tight">
              <h2 className="impact-card-title">{t("programs.internship.intro.title")}</h2>
              <p className="home-about-body impact-body">{t("programs.internship.intro.p1")}</p>
              <p className="home-about-body impact-body">{t("programs.internship.intro.p2")}</p>
            </div>
          </Col>

          <Col md={5} className="impact-internship-right">
            <div className="policy-card impact-image-card impact-image-card--large">
              <Tilt className="impact-tilt" tiltMaxAngleX={6} tiltMaxAngleY={6}>
                <img
                  src={myImg}
                  className="img-fluid impact-image"
                  alt={t("programs.internship.images.internsAlt")}
                  loading="lazy"
                  decoding="async"
                />
              </Tilt>
            </div>
          </Col>
        </Row>

        <div className="impact-centered-cards" aria-label={t("programs.internship.aria.details")}>
          <div className="policy-card impact-copy-card">
            <h2 className="impact-card-title">{t("programs.internship.partnership.title")}</h2>
            <p className="home-about-body impact-body">{t("programs.internship.partnership.p1")}</p>
            <p className="home-about-body impact-body">{t("programs.internship.partnership.p2")}</p>
          </div>

          <div className="policy-card impact-copy-card">
            <h2 className="impact-card-title">{t("programs.internship.experience.title")}</h2>
            <p className="home-about-body impact-body">{t("programs.internship.experience.lead")}</p>
            <ul className="impact-list">
              {experienceItems.map((item) => (
                <li key={item.label}>
                  <span className="purple">{item.label}:</span> {item.text}
                </li>
              ))}
            </ul>
            <p className="home-about-body impact-body">{t("programs.internship.experience.p1")}</p>
          </div>

          <div className="policy-card impact-copy-card">
            <h2 className="impact-card-title">{t("programs.internship.beyond.title")}</h2>
            <p className="home-about-body impact-body">{t("programs.internship.beyond.lead")}</p>
            <ul className="impact-list">
              {beyondItems.map((item) => (
                <li key={item}>
                  <span className="purple">{item}</span>
                </li>
              ))}
            </ul>
            <p className="home-about-body impact-body">{t("programs.internship.beyond.p1")}</p>

            <div className="impact-apply-row">
              <Button onClick={onApply} className="custom-yellow-btn impact-apply-btn">
                {t("common.applyHere")}
              </Button>
            </div>
          </div>
        </div>
      </section>

      <section className="impact-section" aria-label={t("programs.internship.aria.video")}>
        <h2 className="impact-section-heading">{t("common.summerInternshipProgram")}</h2>
        <div className="policy-card impact-video-card">
          <div className="impact-video">
            <iframe
              title={t("programs.internship.videoIframeTitle")}
              src={`https://www.youtube.com/embed/${videoId}`}
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      </section>
    </>
  );
}
export default Impact2;
